import {NgModule} from '@angular/core';
import {UiFormsFormRowComponent} from './ui-forms-form-row.component';
import {DecimalInputComponent} from './decimal-input.component';
import {MultiSelectInputComponent} from './multi-select-input.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [UiFormsFormRowComponent, DecimalInputComponent, MultiSelectInputComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [UiFormsFormRowComponent, DecimalInputComponent, MultiSelectInputComponent],
})
export class UiFormsModule {}
